import { useMemo, useState } from 'react';

import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

import { getStoredComposeTeamSelection } from 'lib/compose';

export const useComposeInit = (so5LeaderboardSlug: string) => {
  const { currentUser } = useCurrentUserContext();

  // Memoize composeSessionId to ensure it says the same during the compose session
  const composeSessionId = useMemo(
    () => `${currentUser?.slug}-${so5LeaderboardSlug}-${new Date().getTime()}`,
    [currentUser?.slug, so5LeaderboardSlug]
  );

  const [onLoadComposeTeamSelection] = useState(
    getStoredComposeTeamSelection(so5LeaderboardSlug)
  );

  return {
    composeSessionId,
    autoSavedBenchObjectsIds: onLoadComposeTeamSelection?.benchObjectIds || [],
  };
};
